import React, { useState, useEffect, createContext, useContext } from 'react';
import Header from '../../Components/Header';
import Sidebar from '../../Components/Sidebar';
import Footer from '../../Components/Footer'
import MainContent from '../../Components/MainContent';
import '../../Assets/styles/Layout.css';
import { Toaster, toast } from 'react-hot-toast';

export const MenuContext = createContext();

export function ContextApi() {
  const context = useContext(MenuContext)
  if (context === undefined) {
    throw new Error('ContextApi must be used within a MenuContext.Provider')
  }
  return context
}
const Dashboard = () => {
  const [selectedMenu, setSelectedMenu] = useState('Dashboard');
  const [FormID, setFormID] = useState(1000)
  const [userPermissionsMap, setUserPermissionsMap] = useState({});
  const setFormPermissions = (formId, permissions) => {
  setUserPermissionsMap(prev => ({
    ...prev,
    [formId]: structuredClone(permissions)
  }));
};

  const [UserPermissions,setUserPermissions]=useState(
    {isAdd:false,
      isEdit: false,
      isView: false,
      isDelete: false,
      isNotification: false })
  const [UnitId,setUnitId] = useState('')
  const [alert, setAlert] = useState({ type: '', message: '', show: false });

  const [openTabs, setOpenTabs] = useState([{ title: 'Dashboard', FormID: 1000 }]);
  const [activeTab, setActiveTab] = useState('Dashboard');

  useEffect(() => {
    if (alert.show) {
      if (alert.type === 'error') {
        toast.error(alert.message);
      } else if (alert.type === 'success') {
        toast.success(alert.message);
      } else {
        toast(alert.message); // Default toast
      }
    }
  }, [alert]);

  const openMenuTab = (title, formId) => {
    const exists = openTabs.find(tab => tab.title === title);
    if (!exists) {
      setOpenTabs(prev => [...prev, { title, FormID: formId }]);
    }
    setActiveTab(title);
    setSelectedMenu(title);
    setFormID(formId);
  };

  const closeTab = (title) => {
    setOpenTabs(prev => prev.filter(tab => tab.title !== title));
    if (activeTab === title && openTabs.length > 1) {
      const remainingTabs = openTabs.filter(tab => tab.title !== title);
      const lastTab = remainingTabs[remainingTabs.length - 1];
      setActiveTab(lastTab.title);
      setSelectedMenu(lastTab.title);
      setFormID(lastTab.FormID);
    }
  };

  return (
    <MenuContext.Provider value={{
      selectedMenu,
      setSelectedMenu,
      FormID,
      setFormID,
      alert: (val) => setAlert(val),
      setUnitId,
      UnitId,
      setUserPermissions,
      UserPermissions,
      userPermissionsMap,
      setFormPermissions,
      openMenuTab,
      openTabs,
      activeTab,
      setActiveTab,
      closeTab
    }}
    >

      <div className="app-container">
        <Header />
        <div className="body-container">
          <Sidebar />
          <MainContent />
        </div>
      </div>
      
        <Footer />
      <Toaster
        position="top-center" 
        toastOptions={{
          style: {
            maxWidth: '500px',  
            whiteSpace: 'pre-wrap', 
            wordBreak: 'break-word', 
            fontSize: '14px', 
          },
          error: {
            style: {
              border: '1px solid red',
              padding: '6px'
            }
          }
        }}
      />

    </MenuContext.Provider>
  );
};

export default Dashboard;
